import React, { useCallback } from "react";
import styles from "./Toggle.module.scss";

interface Props {
  id: string;
  value: string;
  active: boolean;
  className?: string;
  title?: string;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent, newActive: boolean) => void;
}

const Toggle = ({ id, active, className = "", title = "", disabled, onChange }: Props): JSX.Element => {
  const onChangeHandler = useCallback(
    (event: React.ChangeEvent) => {
      if (onChange) {
        onChange(event, !active);
      }
    },
    [active, onChange],
  );

  return (
    <label className={`${styles.toggle} ${className} ${active ? styles.active : ""} ${disabled ? styles.disabled : styles.notDisabled}`.trim()} htmlFor={id} title={title}>
      <input type="checkbox" id={id} checked={active} onChange={onChangeHandler} disabled={disabled} />
      <span className={styles.notch}></span>
    </label>
  );
};

export default Toggle;
